import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon';
import React from 'react';

export const BlockFiled = Styled(
	createSvgIcon(
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM14.891 6.523C14.5015 5.97637 14.0236 5.49849 13.477 5.109L5.109 13.477C5.49849 14.0236 5.97637 14.5015 6.523 14.891L14.891 6.523Z'
				fill='currentColor'
			/>
		</svg>,
		'BlockFiled'
	)
);

export default BlockFiled;
